'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ContrastService.$inject = ['$window'];


var _module = _angular2.default.module('cb.core.a11y.ContrastService', []);

_module.service('ContrastService', ContrastService);

exports.default = _module;

/**
 * ContrastService
 *
 * Service for handling the high contrast display property.
 */

function ContrastService($window) {
    var service = {
        get: get,
        toggleContrast: toggleContrast,
        enable: enable,
        disable: disable
    };

    return service;

    // get a11y.contrast value from localstorage
    function get() {
        return $window.localStorage.getItem('a11y.contrast');
    }

    // turn contrast on or off based on localstorage value
    function toggleContrast() {
        var savedContrast = $window.localStorage.getItem('a11y.contrast');

        // turn on contrast
        if (typeof savedContrast !== 'undefined' && savedContrast === 'true') {
            _angular2.default.element('.site').addClass('highcontrast');
        } else {
            // turn off contrast
            _angular2.default.element('.site').removeClass('highcontrast');
        }
    }

    // set localstorage item
    function enable() {
        $window.localStorage.setItem('a11y.contrast', 'true');
        toggleContrast();
    }

    // remove localstorage item
    function disable() {
        $window.localStorage.removeItem('a11y.contrast');
        toggleContrast();
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/a11y/contrast.service.js
// module id = 766
// module chunks = 0